"use client";

/*eslint-disable */
import React from "react";
import Accordion from "./Accordion";
import { Link } from "react-router-dom";

interface DetalleProps {
  product: any;
}

const questionsAnswers = [
  {
    question: "How many team members can I invite?",
    answer:
      "You can invite up to 2 additional users on the Free plan. There is no limit on team members for the Premium plan.",
  },
  {
    question: "What is the maximum file upload size?",
    answer:
      "No more than 2GB. All files in your account must fit your allotted storage space.",
  },
  {
    question: "How do I reset my password?",
    answer: `Click “Forgot password” from the login page or “Change password” from your profile page. A reset link will be emailed to you.`,
  },
  {
    question: "Can I cancel my subscription?",
    answer: `Yes! Send us a message and we’ll process your request no questions asked.`,
  },
];

const DetalleComponent: React.FC<DetalleProps> = ({ product }) => {
  //console.log(product);
  //align-items-center
  return (
    <>
      <div className="faq-area with-top-border ptb-100">
        <div className="container">
          <div className="row m-0">
            <div className="col-lg-6 col-md-12 p-0">
              <div
                className="btn-style-one gris-orange-color mb-4"
                onClick={() => {localStorage.setItem("back_products", "true"), window.history.back()}}
              >
                Volver {/* <i className="bx bx-chevron-right"></i> */}
              </div>
              <div className="faq-image" data-aos="fade-up">
                <div>
                  <img
                    src={product?.name !== "Laboratorios" ? `/images/fotos/600x600/${product?.slug?.replace(/[^a-zA-Z0-9]/g, "-")}.webp` : "/images/laboratorios.webp"}
                    alt="faq-image"
                    width={789}
                    height={588}
                    onError={(e) => { e.currentTarget.src = "/images/productos.webp"; }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 p-0">
              <div className="faq-accordion">
                <div className="section-title">
                  <h2>{product?.name}</h2>
                </div>
                <div className="courses-details-info mb-4">
                  <ul className="info">
                    {Array.isArray(product?.composicion) ? (
                      product.composicion.map((item: any, index: number) => (
                        <li key={index}>
                          <div className="d-flex justify-content-between align-items-center">
                            <span>{item.name}</span>
                            {item.valor}
                          </div>
                        </li>
                      ))
                    ) : // Validamos que product?.composicion sea un objeto antes de usar Object.keys
                    product?.composicion &&
                      typeof product?.composicion === "object" ? (
                      Object.keys(product?.composicion).map(
                        (key: any, index: number) => (
                          <li key={index}>
                            <div className="d-flex justify-content-between align-items-center">
                              <span>{key}</span> {/* Muestra la clave */}
                              {product?.composicion[key]}{" "}
                              {/* Muestra el valor correspondiente a la clave */}
                            </div>
                          </li>
                        )
                      )
                    ) : (
                      <li>No hay composición disponible</li> // Mensaje de fallback
                    )}
                  </ul>
                </div>

                <div className="accordion" id="faqAccordion">
                  <Accordion product={product} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetalleComponent;
